import {ProcessSingletonTaskSchemaName} from 'graphql-client/__generated/graphqlGlobalTypes';
import {makeReactContext} from 'lib/makeReactContext';

import {ProcessTaskSchemaWithoutFlowchartConfigGraphQL} from '../../../../../graphql-fragments/processes/schemas/__generated/ProcessTaskSchemaWithoutFlowchartConfigGraphQL';

export type SingletonTaskSchemasByName = Partial<
  Record<ProcessSingletonTaskSchemaName, ProcessTaskSchemaWithoutFlowchartConfigGraphQL>
>;

export const SingletonTaskSchemasContext = makeReactContext<SingletonTaskSchemasByName>(
  () => ({}),
  'SingletonTaskSchemasContext'
);
